import React from "react";
import s from "./PaymentDetailsGrid.module.scss";
import { Typography } from "@mui/material";

const PaymentDetailsGrid = ({ items }) => {
  return (
    <div className={s["payment-detail-container"]}>
      {items.map((item, index) => {
        return (
          <div key={index} className={s["item-container"]}>
            <Typography variant="content-s">{item.key}</Typography>
            {typeof item.value === "object" && item.value !== null ? (
              <div>{item.value}</div>
            ) : (
              <Typography variant="content-semibold">
                {item.value ? item.value : "N/A"}
              </Typography>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PaymentDetailsGrid;
